var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep0Walkthrough(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 196,
    viewBox: "0 0 216 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_7374)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.744 119.461C168.659 114.979 164.864 108.504 161.68 102.572C156.268 92.5215 156.879 82.0753 152.424 77.5278C152.424 77.5278 149.933 75.7978 147.606 80.8066C146.039 84.1843 144.933 98.0411 145.494 105.966C146.765 124.123 155.064 135.954 161.829 142.33C168.593 148.707 181.677 122.196 176.727 119.461H176.744Z",
    fill: "#188C7C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.105 76.4404C147.243 81.5811 146.666 83.2946 146.748 83.377C151.137 88.32 157.044 86.1945 154.849 81.5646C152.82 77.2972 150.84 70.756 150.659 69.0259C150.263 65.4176 144.669 69.9157 146.105 76.4239V76.4404Z",
    fill: "#1A395F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.929 74.0018C151.847 66.8675 151.929 59.9309 149.916 62.7319C147.903 65.5329 147.804 68.7952 146.171 71.7445C144.538 74.6939 145.824 77.0335 147.54 80.8231C149.256 84.6127 151.929 74.0018 151.929 74.0018Z",
    fill: "#1A395F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.171 77.3301C140.974 71.3162 136.172 68.1032 135.265 64.3136C134.357 60.524 141.865 61.0018 145.379 63.8687C148.893 66.7357 149.405 65.7306 149.834 70.377C150.263 75.0234 152.276 79.6698 152.276 79.6698L146.187 77.3136L146.171 77.3301Z",
    fill: "#1A395F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.435 83.0146C158.248 93.4278 161.02 99.1451 165.524 101.122C172.223 103.281 170.177 110.811 170.111 115.918C170.161 120.037 171.728 122.361 185.818 112.442C185.818 112.442 183.855 105.39 184.053 100.99C184.251 96.5912 186.693 88.5507 183.756 81.9106C180.769 75.4354 168.428 76.0779 164.435 82.9981V83.0146Z",
    fill: "#1A395F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.06 88.4189C180.06 88.4189 187.98 90.116 182.221 95.3555C176.315 100.546 184.284 104.484 184.284 104.484C184.284 104.484 187.122 91.9284 189.036 85.1071C192.401 73.7218 167.042 64.5773 162.059 74.9905C159.04 81.4987 163.627 84.6622 163.676 84.514C166.778 78.3682 169.567 79.9994 172.998 80.6255C183.211 82.1084 180.06 88.4189 180.06 88.4189Z",
    fill: "#188C7C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.505 116.001C188.029 110.629 191.065 103.775 193.556 97.5304C197.797 86.936 195.998 76.6216 199.908 71.5963C199.908 71.5963 202.185 69.6026 205.056 74.3149C207.003 77.4949 209.659 91.1375 210.006 99.0627C210.798 117.253 203.901 129.94 197.896 137.041C191.89 144.143 175.886 119.279 180.489 116.001H180.505Z",
    fill: "#188C7C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.063 69.8003C205.518 75.0398 206.277 76.671 206.211 76.7699C202.416 82.1742 196.295 80.7242 197.962 75.8801C199.496 71.3985 200.717 64.6926 200.7 62.946C200.684 59.3212 206.739 63.1438 206.063 69.7838V69.8003Z",
    fill: "#1A395F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.007 68.0209C199.265 60.9195 198.407 54.0488 200.717 56.6026C203.027 59.1565 203.505 62.3859 205.469 65.121C207.432 67.8561 206.426 70.3441 205.139 74.2985C203.852 78.2528 200.007 68.0209 200.007 68.0209Z",
    fill: "#1A395F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.112 70.69C210.584 64.1324 214.989 60.3922 215.467 56.5367C215.946 52.6812 208.538 53.9993 205.37 57.2452C202.202 60.4911 201.575 59.5519 201.69 64.2148C201.806 68.8776 200.321 73.7217 200.321 73.7217L206.112 70.69Z",
    fill: "#1A395F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.824 97.4479C205.98 83.344 209.049 121.059 197.698 115.836C184.861 109.674 176.991 110.3 163.033 118.538C159.37 120.746 154.783 120.647 151.038 131.933C141.799 159.828 138.466 180.226 137.278 191.002C162.653 183.95 184.713 168.956 200.585 148.855C204.396 129.841 210.715 111.717 209.824 97.4479Z",
    fill: "#188C7C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.546 140.386C99.4947 136.811 86.9224 134.735 91.5421 119.181C96.1784 103.627 102.118 97.2009 109.543 96.0476C122.61 93.296 131.75 108.273 131.701 123.745C131.651 139.216 109.774 141.391 107.546 140.386Z",
    fill: "#1B2B41"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.227 130.55C111.952 131.67 108.338 130.896 104.725 130.286L103.999 132.395C100.386 131.802 96.2279 128.572 89.1498 131.934C79.4813 136.531 76.4455 160.438 92.1032 172.4C94.0335 175.036 88.3909 185.351 84.9755 193.951C91.3112 194.956 97.7953 195.5 104.411 195.5C119.409 195.5 133.763 192.798 147.045 187.871C147.326 180.391 146.385 170.357 144.62 165.958C144.306 165.183 158.743 161.361 154.668 152.76C147.953 138.557 130.893 129.989 124.26 130.55H124.227Z",
    fill: "#CF2E21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.999 132.164C106.721 125.623 105.995 118.621 102.564 116.973C96.5084 114.139 99.7587 107.581 103.257 107.878C109.097 108.471 103.323 100.414 111.374 99.4748C119.508 98.5192 125.695 105.275 124.26 112.854C122.825 120.433 119.508 118.522 120.68 123.613C121.043 125.294 121.752 128.638 123.253 130.253C124.821 132.115 121.307 135.081 115.746 135.13C110.83 135.18 103.867 132.411 103.917 132.28L103.999 132.148V132.164Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.791 137.914C130.612 127.188 128.962 106.807 134.489 108.026C140.017 109.245 141.518 129.759 135.991 147.421C133.4 155.693 119.591 142.314 122.791 137.914Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.017 139.249C144.372 128.935 154.14 114.254 158.793 115.852C163.445 117.451 150.889 137.766 150.46 148.74C150.163 156.253 138.185 143.582 140.017 139.249Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.583 124.585C127.296 117.764 125.91 111.173 128.253 113.298C130.596 115.424 131.289 118.522 133.334 120.894C135.38 123.267 134.654 125.854 133.829 129.907C133.004 133.96 128.599 124.568 128.599 124.568L128.583 124.585Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.897 128.754C148.068 121.899 149.058 115.243 150.51 118.06C151.962 120.878 151.549 124.008 152.622 126.941C153.694 129.874 152.143 132.049 149.949 135.575C147.755 139.101 146.897 128.754 146.897 128.754Z",
    fill: "#FF8200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7869 87.8587C63.906 91.1375 59.5997 100.233 60.5072 106.197C61.4146 112.162 43.1831 88.2376 43.1831 88.2376C43.1831 88.2376 52.3731 78.6977 58.2468 70.5912C64.1205 62.5013 66.9418 52.5494 79.0687 58.8105C91.179 65.1869 98.9831 70.6242 93.1754 76.7535C87.3677 82.8827 85.2724 82.8004 77.6498 84.794C70.1427 86.8206 67.6513 84.5634 65.7704 87.8587H65.7869Z",
    fill: "#751C48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8738 70.5583C58.8738 70.5583 51.6307 86.4747 61.5137 97.5634C61.5137 97.5634 59.7152 101.847 61.0022 107.004C62.4046 112.178 63.906 115.259 63.906 115.259C63.906 115.259 44.7176 89.5723 43.6616 88.4189C42.4902 87.2491 36.3855 88.2542 36.3855 88.2542L58.8903 70.5583H58.8738Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8099 66.6204C66.8099 66.6204 60.6558 60.1946 58.1644 64.1325C55.5246 68.2846 57.7189 70.8549 57.7684 72.8486C57.9499 78.6977 58.1644 85.1566 63.8401 89.8853C69.5158 94.6141 75.9175 92.538 83.3256 82.5862C90.7502 72.519 81.0157 55.1363 66.7934 66.604L66.8099 66.6204Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8381 100.628C53.3797 93.1147 40.1804 81.2516 38.2665 72.14C35.0327 56.718 33.3663 41.5596 35.8246 35.3479C35.8246 35.3479 33.3663 44.0146 28.301 49.7484C24.9022 53.6039 17.3126 59.0412 15.8772 69.0424C12.2804 93.9385 16.4382 113.793 22.9058 124.898C29.3735 136.003 58.2799 108.059 55.8381 100.628Z",
    fill: "#751C48"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7723 24.3909C27.2781 33.3871 17.6921 53.4885 16.0257 68.3009C15.1842 75.7812 34.9007 53.093 34.9832 52.6317C35.0327 52.401 34.4552 44.5582 36.6496 37.8357C38.679 31.6241 42.9193 23.2045 44.3877 21.2933C47.4235 17.3059 37.59 16.5315 32.7723 24.3909Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3518 24.3417C48.0669 17.1084 54.3366 13.3847 49.6674 14.2745C44.9981 15.1642 41.7808 18.3442 37.326 19.7447C32.8713 21.1452 31.9308 24.7206 30.0499 30.1414C28.169 35.5622 41.3518 24.3417 41.3518 24.3417Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9804 25.3301C32.5084 14.3732 30.7595 6.59629 33.4323 1.93343C36.1052 -2.72943 43.1998 4.88273 43.9753 11.0944C44.7507 17.3061 46.2522 16.7788 42.2429 21.8371C38.2336 26.8954 35.8412 33.4696 35.8412 33.4696L31.9804 25.3301Z",
    fill: "#E64460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9097 109.871C57.521 101.633 45.4271 84.2503 38.9594 86.8041C32.6073 89.3745 24.4567 92.2908 17.8901 97.8105C14.9532 100.216 7.26464 118.126 0.5 137.931C11.3564 155.264 26.4366 169.681 44.3052 179.748C54.6006 156.747 71.0997 152.447 69.4828 134.57C68.6249 125.03 64.7806 115.127 61.9097 109.855V109.871Z",
    fill: "#751C48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_7374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 195,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep0Walkthrough);
export default __webpack_public_path__ + "static/media/step_0_walkthrough.428ed63a1642f3dbc8651ed15e3c5178.svg";
export { ForwardRef as ReactComponent };